import { render, staticRenderFns } from "./i-loader.vue?vue&type=template&id=a465fc02&scoped=true&"
import script from "./i-loader.vue?vue&type=script&lang=js&"
export * from "./i-loader.vue?vue&type=script&lang=js&"
import style0 from "./i-loader.vue?vue&type=style&index=0&id=a465fc02&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a465fc02",
  null
  
)

export default component.exports